import { render, staticRenderFns } from "./PopupChoosePhone.vue?vue&type=template&id=4472fdea&"
import script from "./PopupChoosePhone.vue?vue&type=script&lang=js&"
export * from "./PopupChoosePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports